import { useSelector } from "react-redux";
import { RootState } from "../reducers";
import { languageType } from "../interface/redux/config";

export const useLanguage = () => {
  const language = useSelector<RootState, languageType>(
    (state) => state.config.language
  );
  const isKr = language === "kr";
  return { isKr, language };
};
